<template>
  <div class="warp-spmi-home">
        <ContentSpmi />
  </div>
</template>

<script>
import ContentSpmi from '@/components/spmi/ContentSpmi.vue';

export default {
  components: {
    ContentSpmi
  },
  mounted() {
    console.log('SpmiHome.vue has been mounted');
  },
  beforeUnmount() {
    console.log('❌ SpmiHome.vue is being destroyed');
  }
}
</script>
<style scoped lang="scss">

</style>
